<div class="col-12">
    <h1 style="text-align:center;padding-bottom:25px;margin-top:15px" class="pt-8">CK Capital Finance<br/>Loan Application</h1>
    <!-- <h1 style="text-align:center;padding-bottom:25px;" *ngIf="isReferralValid">Referred By: {{referralDisplayName}}</h1> -->
    <p-messages></p-messages>
    <p-toast key="tst"></p-toast>
    <form *ngIf="applicationForm" [formGroup]="applicationForm">
      <input type="hidden" formControlName="ReferralName" /> 
      <div class="grid boxs">
        <!-- <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Loan Officer</label>
            <input type="text" pInputText formControlName="LoanOfficer" />
          </div>
        </div> -->
        <div class="col-12 sm:col-12 md:col-16">
          <div class="input_fields">
            <label>How Did You Hear About Us?</label>
            <input type="text" pInputText formControlName="HowDidYouHear" />
          </div>
        </div>
        <div class="col-12">
          <h3>BORROWER/ENTITIY INFORMATION</h3>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Entity Name <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="EntityName" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Type <span style="color:red">*</span></label>
            <p-dropdown [options]="entityType" [style]="{'width':'100%'}" formControlName="EntityType"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>EIN Number <span style="color:red">*</span></label>
            <p-inputMask [style]="{'width':'100%'}" mask="99-9999999" formControlName="EINNumber"></p-inputMask>
          </div>
        </div>
        <div class="col-12 sm:col-12">
          <h3>PERSONAL GUARANTOR INFORMATION </h3>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>First Name <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="PersonalFirstName" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Last Name <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="PersonalLastName" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Date of Birth <span style="color:red">*</span></label>
            <p-calendar [style]="{'width':'85%'}" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [inputStyle]="{'width':'85%'}" formControlName="PersonalBirthDate"></p-calendar>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Social Security Number <span style="color:red">*</span></label>
            <p-inputMask mask="999-99-9999" formControlName="PersonalSSN"></p-inputMask>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>Primary Residence Address <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="PersonalPrimaryResidence" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4">
          <div class="input_fields">
            <label>City <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="PersonalCity"/>
          </div>
        </div>
  
  
            <div class="col-12 sm:col-12 md:col-4">
              <div class="input_fields">
                <label>State <span style="color:red">*</span></label>
                <p-dropdown [options]="states" [style]="{'width':'100%'}" formControlName="PersonalState"></p-dropdown>
              </div>
            </div>
            <div class="col-12 sm:col-12 md:col-4">
              <div class="input_fields">
                <label>Zip <span style="color:red">*</span></label>
                <p-inputMask styleClass="p-inputwrapper" mask="99999" formControlName="PersonalZip"></p-inputMask>
              </div>
            </div>
  
  
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Own or Rent?  <span style="color:red">*</span></label>
            <p-dropdown [options]="ownOrRent" [style]="{'width':'100%'}" formControlName="PersonalOwnOrRent"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Number of Years <span style="color:red">*</span></label>
            <input type="number" pInputText formControlName="PersonalOwnOrRentNumberOfYears"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Phone <span style="color:red">*</span></label>
            <p-inputMask mask="(999) 999-9999" formControlName="PersonalPhone"></p-inputMask>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Email Address <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="PersonalEmail" email/>
          </div>
        </div>
        <div class="col-12">
          <h3>BORROWER EXPERIENCE </h3>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label class="big">Number of properties rehabbed and sold within the last 36 months <span style="color:red">*</span></label>
            <input type="number" pInputText formControlName="ExperienceRehab" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label class="big">Number of rental properties currently owned <span style="color:red">*</span></label>
            <input type="number" pInputText formControlName="ExperienceRental" />
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label class="big">Number of properties with PROOF of YOUR ACTUAL ownership history <span style="color:red">*</span></label>
            <input type="number" pInputText formControlName="ExperienceProofOwnership" />
          </div>
        </div>
        <div class="col-12">
          <h3>SUBJECT PROPERTY INFORMATION </h3>
        </div>
        <div class="col-12">
          <p-checkbox binary=true label="Check this if you are only looking to be pre-approved" inputId="PreApprovalOnly" formControlName="SeekingPreApprovalOnly"></p-checkbox>
        </div>
        <div class="col-12">
          <p-checkbox binary=true label="Check this if you do NOT have a subject property picked out" inputId="SubjectPropertyNotPicked" formControlName="NoSubjectProperty"></p-checkbox>
        </div>
        <div class="col-12">
          <p-checkbox binary=true [hidden]="applicationForm.value.NoSubjectProperty" label="Check this if you ARE currently under contract" inputId="UnderContract" formControlName="UnderContract"></p-checkbox>
        </div>
        <div *ngIf="applicationForm.value && !applicationForm.value.NoSubjectProperty" class="col-12">
          <div class="input_fields">
            <label>Property Address <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="SubjectPropertyAddress" />
          </div>
        </div>
        <div *ngIf="applicationForm.value && !applicationForm.value.NoSubjectProperty" class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>City <span style="color:red">*</span></label>
            <input type="text" pInputText formControlName="SubjectCity" />
          </div>
        </div>
  
        <div *ngIf="applicationForm.value && !applicationForm.value.NoSubjectProperty" class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>State <span style="color:red">*</span></label>
            <p-dropdown [options]="states" [style]="{'width':'100%'}" formControlName="SubjectState"></p-dropdown>
          </div>
        </div>
        <div *ngIf="applicationForm.value && !applicationForm.value.NoSubjectProperty" class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Zip <span style="color:red">*</span></label>
            <p-inputMask mask="99999" formControlName="SubjectZip"></p-inputMask>
          </div>
        </div>
          
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Exit Strategy <span style="color:red">*</span></label>
            <p-dropdown [options]="exitStrategy" [style]="{'width':'100%'}" formControlName="PropertyExitStrategy"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Property Type <span style="color:red">*</span></label>
            <p-dropdown [options]="propertyType" [style]="{'width':'100%'}" formControlName="SubjectPropertyType"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <h3>LOAN REQUEST INFORMATION  </h3>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Program Type <span style="color:red">*</span></label>
            <p-dropdown [options]="programType" [style]="{'width':'100%'}" formControlName="LoanProgramType"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Mortgage Type <span style="color:red">*</span></label>
            <p-dropdown [options]="mortgageType" [style]="{'width':'100%'}" formControlName="MortgageType"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Purchase Price </label>
            <input type="number" pInputText formControlName="PurchasePrice" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Loan Term </label>
            <p-dropdown [options]="loanTerm" [style]="{'width':'100%'}" formControlName="LoanTermMonths"></p-dropdown>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Rehab Cost <small>(if applicable) </small></label>
            <input type="number" pInputText formControlName="RehabCost" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>After Repaired Value  <small>(if applicable) </small></label>
            <input type="number" pInputText formControlName="AfterRepairValue"/>
          </div>
        </div>
        <div class="col-12" id="RehabBudgetContainer" *ngIf="applicationForm.value && !applicationForm.value.NoSubjectProperty && applicationForm.value.RehabCost">
          <h3 style="color:white;margin-bottom:0px;">
            <i class="pi pi-exclamation-triangle" style="color:#e72a2b"></i> 
            REHAB BUDGET FORM (REQUIRED) 
            <i class="pi pi-exclamation-triangle" style="color:#e72a2b"></i>
          </h3>
          <app-rehab-budget [rehabTotal]="app.Application.RehabCost" [rehabBudgetForm]="app.Application.RehabBudget"></app-rehab-budget>
        </div>
        <div class="col-12">
          <h6>If Refinancing - please complete the following: </h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Original Purchase Price </label>
            <input type="number" pInputText formControlName="RefinanceOriginalPurchasePrice"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Current Payoff </label>
            <input type="number" pInputText formControlName="RefinanceCurrentPayoff"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Date Acquired </label>
            <p-calendar [style]="{'width':'85%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" formControlName="RefinanceDateAcquired"></p-calendar>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Payment Amount  </label>
            <input type="number" pInputText formControlName="RefinancePaymentAmount"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Mortgage Lender </label>
            <input type="text" pInputText formControlName="RefinanceMortgageLender"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Contact Name </label>
            <input type="text" pInputText formControlName="RefinanceContactName"/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Email </label>
            <input type="text" pInputText formControlName="RefinanceMortgageEmail" email/>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Phone</label>
            <p-inputMask mask="(999) 999-9999" formControlName="RefinancePhone"></p-inputMask>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="signature_pad_box">
            <signature-pad #sigpad1 [options]="signaturePadOptions"  id="SignatureLoanPart"></signature-pad>
            <div class="sign_box">Guarantor Signature</div>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" formControlName="LoanInfoSignatureDate"></p-calendar>
          <div class="sign_box" style="margin-top:5px;">Date</div>
        </div>
        <div class="col-12">
          <h6>If Leased - please complete the following: </h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Monthly Rent </label>
            <input type="number" pInputText formControlName="LeasedMonthlyRent" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <div class="col-12 sm:col-6 md:col-8 lg:col-8">
              <div class="input_fields">
                <label>Lease Expiration Date</label>
                <p-calendar [monthNavigator]="true" [disabled]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'62%'}" formControlName="LeasedExpiration"></p-calendar>
              </div>
            </div>
            <div class="col-12 sm:col-6 md:col-6 lg:col-6">
              <p-checkbox binary=true label="Already Expired & Doing Month-to-month" inputId="LeasedExpired" formControlName="LeaseMonthToMonth"></p-checkbox>
            </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Yearly Taxes </label>
            <input type="number" pInputText formControlName="LeasedYearlyTaxes" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Yearly Insurance </label>
            <input type="number" pInputText formControlName="LeasedYearlyInsurance" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Yearly HOA Dues <small>(if applicable)</small></label>
            <input type="number" pInputText formControlName="LeasedYearlyHOADues" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>HOA Contact</label>
            <input type="text" pInputText formControlName="LeasedHOAContact" />
          </div>
        </div>
        <div class="col-12">
          <h3>CONTACT INFORMATION</h3>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <h6>Interior Access Contact Information </h6>
          <div class="col-12">
            <div class="input_fields">
              <label>Contact Name</label>
              <input type="text" pInputText formControlName="InteriorContact" />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Relationship</label>
              <input type="text" pInputText formControlName="InteriorContactRelationship" />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Email</label>
              <input type="text" pInputText formControlName="InteriorContactEmail" email />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Phone</label>
              <p-inputMask mask="(999) 999-9999" formControlName="InteriorContactPhone"></p-inputMask>
            </div>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <h6>Title/Escrow Contact Information</h6>
          <div class="col-12">
            <div class="input_fields">
              <label>Company Name</label>
              <input type="text" pInputText formControlName="ContactTitleCompanyName" />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Contact Name</label>
              <input type="text" pInputText formControlName="ContactTitleContactName" />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Email</label>
              <input type="text" pInputText formControlName="ContactTitleEmail" email />
            </div>
          </div>
          <div class="col-12">
            <div class="input_fields">
              <label>Phone</label>
              <p-inputMask mask="(999) 999-9999" formControlName="ContactTitlePhone"></p-inputMask>
            </div>
          </div>
        </div>
        <div class="col-12">
          <h6>Home Owners Insurance (HOI) Contact Information (if applicable)</h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Contact Name</label>
            <input type="text" pInputText formControlName="HOAContactName" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Relationship </label>
            <input type="text" pInputText formControlName="HOARelationship" />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Email</label>
            <input type="text" pInputText formControlName="HOAContactEmail" email />
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="input_fields">
            <label>Phone </label>
            <p-inputMask mask="(999) 999-9999" formControlName="HOAPhone"></p-inputMask>
          </div>
        </div>
        <div class="col-12">
          <h3>DECLARATIONS </h3>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>1. Are there any outstanding judgements against you? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsJudgements"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>2. Have you declared bankruptcy within the past 3 years? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsBankrupt"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>3. Have you been foreclosed on or given title or deed in lieu in the last 3 years? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsForeclosed"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>4. Are you a party to a lawsuit? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsLawsuit"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>5. Have you been charged or found guilty of a criminal offense in the past? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsCriminalOffense"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>6. Are you presently delinquent or in default on any Federal debt or any other loan, mortgage, financial
              obligation, bond, or loan guarantee? <span style="color:red">*</span></label>
              <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsDelinquent"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>7. Are you a US Citizen? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsUSCitizen"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>8. Are you a permanent resident alien? <span style="color:red">*</span></label>
            <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsPermanentResident"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields large">
            <label>9. Have you, directly or indirectly, been obligated on any loan which resulted in a foreclosure to be initiated,
              transfer of title in lieu of foreclosure, or judgements? (This would include such loans as home mortgage loans,
              SBA loans, home improvement loans, educational loans, manufactured (mobile) home loans, any mortgage,
              financial obligation, bond, or loan guarantee. If “Yes,” provide the details, including date, name and address of
              lender, FHA or VA case number, if any, and reasons for the action.) <span style="color:red">*</span></label>
              <p-dropdown [options]="yesno" [style]="{'width':'100%'}" formControlName="DeclarationsObligatedForeclosure"></p-dropdown>
          </div>
        </div>
        <div class="col-12">
          <p>If you answered yes to 1,4, or 6 please provide a detailed letter of explanation with your application.</p>
          <textarea [rows]="2" [cols]="30" [style]="{'width':'100%'}" pInputTextarea autoResize="autoResize" formControlName="DeclarationsExplanations"></textarea>
        </div>
        <div class="col-12">
          <h3>INFORMATION FOR GOVERNMENT MONITORING PURPOSES </h3>
        </div>
        <div class="col-12">
          <p>The following information is requested by the Federal Government for certain types of loans related to a dwelling in order to monitor the
            lender's compliance with equal credit opportunity, fair housing and home mortgage disclosure laws . You are not required to furnish this in
            formation, but are encouraged to do so . The law provides that a lender may not discriminate either on the basis of t his information, or on
            whether you choose to furnish it. If you furnish the information, please provide both ethnicity and race. For race, you may check more
            than one designation. If you do not furnish ethnicity, race, or sex, under Federal regulations, this lender is required to note the information
            on the basis of visual observation and surname if you have made this application in person. If you do not wish to furnish the information,
            please check the box below. (Lender must review the above material to assure that the disclosures satisfy all requirements to which the
            lender is subject under applicable state law for the particular type of loan applied for.)</p>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="hedingbox">Borrower:</div>
          <div class="radio-box">
            <p-checkbox binary="true" label="I do not wish to furnish this information." inputId="DoNotFurnishInfo" formControlName="DoNotFurnishPersonalInfo"></p-checkbox>
          </div>
        </div>
        <div *ngIf="!do_not_furnish_info" class="col-12 sm:col-12 md:col-6">
          <div class="hedingbox">Sex:</div>
          <div class="radio-box">
            <p-radioButton value="true" label="Female" inputId="opt1" formControlName="SexFemale"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="Male" inputId="opt2" formControlName="SexMale"></p-radioButton>
          </div>
        </div>
        <div *ngIf="!do_not_furnish_info" class="col-12">
          <div class="hedingbox">Ethnicity:</div>
          <div class="radio-box">
            <p-radioButton value="true" label="Hispanic or Latino" inputId="opt3" formControlName="HispanicLatino"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="Not Hispanic or Latino" inputId="opt4" formControlName="NotHispanicLatino"></p-radioButton>
          </div>
        </div>
        <div *ngIf="!do_not_furnish_info" class="col-12">
          <div class="hedingbox">Race:</div>
          <div class="radio-box">
            <p-radioButton value="true" label="American Indian or Alaska Native" inputId="opt5" formControlName="Indian"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="Black or African American" inputId="opt6" formControlName="AfricanAmerican"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="White" inputId="opt7" formControlName="White"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="Asian" inputId="opt8" formControlName="Asian"></p-radioButton>
          </div>
          <div class="radio-box">
            <p-radioButton value="true" label="Native Hawaiian or Other Pacific Islander" inputId="opt9" formControlName="Hawaiian"></p-radioButton>
          </div>
        </div>
        <div class="col-12">
          <p>To be Completed by Loan Originator: This information was provided: In a face-to-face interview In a telephone interview By the applicant
            and submitted by fax or mail By the applicant and submitted via e-mail or the Internet</p>
        </div>
        <div class="col-12">
          <h3>ACKNOWLEDGEMENT AND AGREEMENT </h3>
        </div>
        <div class="col-12">
          <p>Each of the undersigned specifically represents to Lender and to Lender's actual or potential agents, brokers, processors, attorneys, insurers, servicers,
            successors and assigns and agrees and acknowledges that: (1) the information provided in this application is true and correct as of the date set forth
            opposite my signature and that any intentional or negligent misrepresentation of this information contained in this application may result in civil liability,
            including monetary damages, to any person who may suffer any loss due to reliance upon any misrepresentation that I have made on this application, and/
            or in criminal penalties including, but not limited to, fine or imprisonment or both under the provisions of Title 18, United States Code, Sec. 1001, et seq.; (2) the
            loan requested pursuant to this application (the "Loan") will be secured by a mortgage or deed of trust on the property described in this application; (3) the
            property will not be used for any illegal or prohibited purpose or use; (4) all statements made in this application are made for the purpose of obtaining a
            commercial mortgage loan; (5) the property will be occupied as indicated in this application; (6) the Lender, its servicers, successors or assigns may retain the
            original and/or an electronic record of this application, whether or not the Loan is approved; (7) the Lender and its agents, brokers, insurers, servicers,
            successors, and assigns may continuously rely on the information contained in the application, and I am obligated to amend and/or supplement the
            information provided in this application if any of the material facts that I have represented herein should change prior to closing of the Loan; (8) in the event
            that my payments on the Loan become delinquent, the Lender, its servicers, successors or assigns may, in addition to any other rights and remedies that it
            may have relating to such delinquency, report my name and account information to one or more consumer reporting agencies; (9) ownership of the Loan
            and/or administration of the Loan account may be transferred with such notice as may be required by law; (10) neither Lender nor its agents, brokers,
            insurers, servicers, successors or assigns has made any representation or warranty, express or implied, to me regarding the property or the condition or value
            of the property; and (11) my transmission of this application as an "electronic record" containing my "electronic signature," as those terms are defined in
            applicable federal and/or state laws (excluding audio and video recordings), or my facsimile transmission of this application containing a facsimile of my
            signature, shall be as effective, enforceable and valid as if a paper version of this application were delivered containing my original written signature.
            Acknowledgement. Each of the undersigned hereby acknowledges that any owner of the Loan, its servicers, successors and assigns, may verify or reverify
            any information contained in this application or obtain any information or data relating to the Loan, for any legitimate business purpose through any source,
            including a source named in this application or a consumer reporting agency.</p>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <input type="text" pInputText formControlName="AckAgreementPrintedName" style="margin-bottom:5px;width:100%">
          <div class="sign_box">Guarantor Printed Name <span style="color:red">*</span></div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" formControlName="AckAgreementDate"></p-calendar>
          <div class="sign_box" style="margin-top:5px;">Date</div>
        </div>
        <div class="col-12">
          <div class="signature_pad_box">
            <signature-pad #sigpad2 [options]="signaturePadOptions"  id="AckAgreementSignature"></signature-pad>
            <div class="sign_box">Guarantor Signature <span style="color:red">*</span></div>
          </div>
        </div>
        <div class="col-12">
          <h3>BORROWER SIGNATURE AUTHORIZATION</h3>
        </div>
        <div class="col-12">
          <p>Privacy Act Notice: This information is to be used by the agency collecting it or its assignees in determining whether you
            qualify as a prospective mortgagor under its program. It will not be disclosed outside the agency except as required and
            permitted by law. You do not have to provide this information, but if you do not, your application for approval as a prospective mortgagor or borrower may be delayed or rejected. The information requested in this form is authorized by Title
            38, USC, Chapter 37 (if VA); by 12 USC, Section 1701 et. Seq. (if HUD/FHA); by 42 USC, Section 1452b (if HUD/CPD); and Title
            42 USC, 1471 et. Seq., or 7 USC, 1921 et. seq. (if USDA/FHA). </p>
        </div>
        <div class="col-12">
          <h6>PART 1 - GENERAL INFORMATION</h6>
        </div>
        <div class="col-12">
          <div class="input_fields">
            <label>1. Borrower Name</label>
            {{applicationForm.value.PersonalFirstName}} {{applicationForm.value.PersonalLastName}}
          </div>
        </div>
        <div class="col-12">
          <div class="input_fields in_box">
            2. Name and address of Lender/Broker
            <strong>CK Capital LLC, its affiliates, successors and/or assigns. 429 S 119th St. West, Wichita, KS 67235</strong>
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4">
          <div class="input_fields">
            <label>3. Date</label>
            {{applicationForm.value.LoanInfoSignatureDate | date: 'MM/dd/yyyy'}}
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4">
          <div class="input_fields">
            <label>4. Social Security Number</label>
            {{applicationForm.value.PersonalSSN}}
          </div>
        </div>
        <div class="col-12 sm:col-12 md:col-4">
          <div class="input_fields">
            <label>4. Date of Birth</label>
            {{applicationForm.value.PersonalBirthDate | date: 'dd/MM/yyyy'}}
          </div>
        </div>
        <div class="col-12">
          <h6>PART 2 - BORROWER AUTHORIZATION</h6>
        </div>
        <div class="col-12">
          <p>I hereby authorize the Lender/Broker, its affiliates, successors and/or assigns to verify my past and present employment
            earnings records, bank accounts, stock holdings, and any other asset balances that are needed to process my mortgage
            loan application. I further authorize the Lender/Broker, its affiliates, successors and/or assigns to order a consumer credit
            report and criminal background checks to verify other credit information, including but not limited to past and present
            mortgages and landlord references. It is understood that a copy of this form will also serve as authorization. * </p> <br/>
            <p>The information the Lender/Broker, its affiliates, successors and/or assigns obtains is only to be used in the processing of my
              application for a mortgage loan.</p>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <input type="text" pInputText formControlName="BorrowerAuthPrintedName" style="margin-bottom:5px;width:100%">
          <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" formControlName="BorrowerAuthSignatureDate"></p-calendar>
          <div class="sign_box" style="margin-top:5px;">Date</div>
        </div>
        <div class="col-12">
          <div class="signature_pad_box">
            <signature-pad #sigpad3 [options]="signaturePadOptions"  id="signatureCanvas"></signature-pad>
          <div class="sign_box">Guarantor Signature <span style="color:red">*</span></div>
        </div>
        </div>
        <div class="col-12">
          <h3>ECOA - EQUAL CREDIT OPPORTUNITY ACT</h3>
        </div>
        <div class="col-12">
          <p>The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of
            race, color, religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a
            binding contract); because all or part of the applicant’s income derives from any public assistance program or because
            the applicant has in good faith exercised any right under the Consumer Credit Protection Act. The Federal Agency that
            administers compliance with this law concerning this company is the Federal Trade Commission, Equal Credit Opportunity,
            Washington, DC 20580. <br/> <br/>
            We are required to disclose to you that you need not disclose income from alimony, child support or separate
            maintenance payments if you choose not to do so. <br/> <br/>
            Having made this disclosure to you, we are permitted to inquire if any of the income shown on your application is derived
            from such a source and to consider the likelihood of consistent payment as we do with any income on which you are
            relying to qualify for the loan for which you are applying.  </p>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <input type="text" pInputText formControlName="ECOAPrintedName" style="margin-bottom:5px;width:100%">
          <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" formControlName="ECOASignatureDate"></p-calendar>
          <div class="sign_box" style="margin-top:5px;">Date</div>
        </div>
        <div class="col-12">
          <div class="signature_pad_box">
            <signature-pad #sigpad4 [options]="signaturePadOptions"  id="signatureCanvas"></signature-pad>
          <div class="sign_box">Guarantor Signature <span style="color:red">*</span></div>
        </div>
        </div>
        <div class="col-12" style="margin-top:25px;">
          <strong>{{applicationForm.value.SubjectPropertyAddress}}, {{applicationForm.value.SubjectCity}}, {{applicationForm.value.SubjectState}}, {{applicationForm.value.SubjectZip}}</strong>
          <div class="sign_box">Property Full Address</div>
        </div>
        <div class="col-12">
          <h3>DECLARATION OF NON-OWNER OCCUPANCY</h3>
        </div>
        <div class="col-12">
          <p>I (“Borrower”) certify and represent to Lender (“Originator”) as follows: </p> <br/> <br/>
          <p>I have applied to Originator for a mortgage, deed of trust or other security instrument secured by the real property
            located at: </p> <br/><br/>
          <p> <span class="sign_box1"><strong>{{applicationForm.value.SubjectPropertyAddress}}, {{applicationForm.value.SubjectCity}}, {{applicationForm.value.SubjectState}}, {{applicationForm.value.SubjectZip}}</strong></span> (the “Property”) for investment purposes. I (“Borrower”) hereby
            declare that neither I nor any member of the borrowing entity are currently utilizing the property as a principal residence.
            Additionally, I declare that neither I nor any member of the borrowing entity are currently utilizing the property as a second
            home. </p> <br/><br/>
          <p>I (“Borrower”) understand and represent that I understand the difference between a consumer loan for personal purposes
            and a commercial loan for business purposes. Borrower represents and understands that this loan is not a consumer loan
            and therefore may not be subject to the various laws relating to consumer loans in the various states or federal laws. I
            declare that all loan proceeds are for investment/business purpose, and no loan proceeds are for consumer, family, and/
            or household purposes. </p>
          <p>The lender, broker, assignees, and successors may rely upon this information. I declare under penalty of perjury the
            foregoing is true and correct.</p>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <input type="text" pInputText formControlName="NonOwnerOccupancyPrintedName" style="margin-bottom:5px;width:100%">
          <div class="sign_box">Guarantor Name Printed <span style="color:red">*</span></div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <p-calendar [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="true" formControlName="NonOwnerOccupancySignatureDate"></p-calendar>
          <div class="sign_box" style="margin-top:5px;">Date</div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <div class="signature_pad_box">
          <signature-pad #sigpad5 [options]="signaturePadOptions"  id="signatureCanvas"></signature-pad>
          <div class="sign_box">Guarantor Signature <span style="color:red">*</span></div>
        </div>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
          <input type="text" pInputText formControlName="NonOwnerOccupancyEntity" style="margin-bottom:5px;width:100%">
          <div class="sign_box">Entity Name <span style="color:red">*</span></div>
        </div>
  
        <div class="col-12">
          <p-accordion>
            <p-accordionTab header="Click To Add Additional Business Partner 1" [selected]="false">
              <div class="grid">
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>First Name</label>
                    <input type="text" pInputText formControlName="Partner1FirstName" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Last Name</label>
                    <input type="text" pInputText formControlName="Partner1LastName" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Date of Birth</label>
                    <p-calendar [style]="{'width':'100%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" formControlName="Partner1Birthdate"></p-calendar>
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Social Security Number</label>
                    <p-inputMask [style]="{'width':'100%'}" mask="999-99-9999" formControlName="Partner1SSN"></p-inputMask>
                  </div>
                </div>
                <div class="col-12">
                  <div class="input_fields">
                    <label>Primary Residence</label>
                    <input type="text" pInputText formControlName="Partner1PrimaryResidence" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Phone</label>
                    <p-inputMask [style]="{'width':'100%'}" mask="(999) 999-9999" formControlName="Partner1Phone"></p-inputMask>
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Email Address</label>
                    <input type="text" pInputText formControlName="Partner1Email" email/>
                  </div>
                </div>
                <div class="col-12">
                  <div class="input_fields">
                    <label>Ownership Percentage</label>
                    <input type="number" pInputText formControlName="Partner1Ownership" />
                  </div>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
  
        <div class="col-12">
          <p-accordion>
            <p-accordionTab header="Click To Add Additional Business Partner 2" [selected]="false">
              <div class="grid">
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>First Name</label>
                    <input type="text" pInputText formControlName="Partner2FirstName" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Last Name</label>
                    <input type="text" pInputText formControlName="Partner2LastName" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Date of Birth</label>
                    <p-calendar [style]="{'width':'100%'}" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [inputStyle]="{'width':'85%'}" formControlName="Partner2Birthdate"></p-calendar>
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Social Security Number</label>
                    <p-inputMask [style]="{'width':'100%'}" mask="999-99-9999" formControlName="Partner2SSN"></p-inputMask>
                  </div>
                </div>
                <div class="col-12">
                  <div class="input_fields">
                    <label>Primary Residence</label>
                    <input type="text" pInputText formControlName="Partner2PrimaryResidence" />
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Phone</label>
                    <p-inputMask [style]="{'width':'100%'}" mask="(999) 999-9999" formControlName="Partner2Phone"></p-inputMask>
                  </div>
                </div>
                <div class="col-12 sm:col-12 md:col-6">
                  <div class="input_fields">
                    <label>Email Address</label>
                    <input type="text" pInputText formControlName="Partner2Email" email />
                  </div>
                </div>
                <div class="col-12">
                  <div class="input_fields">
                    <label>Ownership Percentage</label>
                    <input type="number" pInputText formControlName="Partner2Ownership" />
                  </div>
                </div>
              </div>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </form>
  </div>

  